<template>
  <div class="d-flex mb-4 row col-12 justify-content-around align-items-center m-0 insurers-row flex-row"  >
    <img
      src="/images/insurers/zurich(grey).png"
      alt="Zurich | Public Liability Insurance"
      width="auto"
      class="my-3 mx-1 px-2"
      style="height: 100%"
    />
    <img
      src="/images/insurers/vero(grey).png"
      alt="Vero | Public Liability Insurance"
      width="auto"
     style="height: 100%"
      class="my-3 mx-1 px-2"
    />
    <img
      src="/images/insurers/steadfast(grey).png"
      alt="Steadfast | Public Liability Insurance"
      width="auto"
     style="height: 100%"
      class="my-3 mx-1 px-2"
    />
    <img
      src="/images/insurers/qbe(grey).png"
      alt="QBE | Public Liability Insurance"
      width="auto"
     style="height: 100%"
      class="my-3 mx-1 px-2"
    />
    <img
      src="/images/insurers/protecsure(grey).png"
      alt="Protecsure | Public Liability Insurance"
      width="auto"
     style="height: 100%"
      class="my-3 mx-1 px-2"
    />
    <img
      src="/images/insurers/cgu(grey).png"
      alt="CGU | Public Liability Insurance"
      width="auto"
     style="height: 100%"
      class="my-3 mx-1 px-2"
    />
    <img
      src="/images/insurers/lloyds(grey).png"
      alt="LLOYD's | Public Liability Insurance"
      width="auto"
     style="height: 100%"
      class="my-3 mx-1 px-2"
    />
    <img
      src="/images/insurers/brooklyn(grey).png"
      alt="Brooklyn | Public Liability Insurance"
      width="auto"
     style="height: 100%"
      class="my-3 mx-1 px-2"
    />
    <img
      src="/images/insurers/allianz(grey).png"
      alt="Allianz | Public Liability Insurance"
      width="auto"
     style="height: 100%"
      class="my-3 mx-1 px-2"
    />
    <img
      src="/images/insurers/aig(grey).png"
      alt="AIG | Public Liability Insurance"
      width="auto"
     style="height: 100%"
      class="my-3 mx-1 px-2"
    />
  </div>
</template>

<script>
/**
 *  Import dependencies & event bus
 */


export default {

  data() {
    return {};
  },
  watch: {},
  mounted() {},

  computed: {},
  beforeMount() {},

  methods: {},
};
</script>

<style>
@media screen and (max-width: 768px) {
  .insurers-row {
    display: none !important;
  }

}
@media screen and (max-width: 1024px) {
  .insurers-row {
    height: 30px !important;
  }
}

.insurers-row {
  height: 40px;
}

</style>
    